import React from "react";
import Avatar from '@mui/material/Avatar';

const defaultImageHeight = '40px';

export const FallbackAvatar = ({height = defaultImageHeight, userInitials}) => {

  return (
      <Avatar
        sx={{height: height, width: height}}
        alt='FallbackImage'
        data-testid='FallbackImage'
      >
        {userInitials}
      </Avatar>
  );
};
